interface FullscreenStatusProps {
  title: string;
  body?: string;
}

export function FullscreenStatus({ title, body }: FullscreenStatusProps) {
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="max-w-lg rounded-[2rem] border border-white/70 bg-white/75 p-8 text-center shadow-panel">
        <p className="font-display text-4xl text-ink">{title}</p>
        {body ? <p className="mt-4 text-base leading-7 text-ink/65">{body}</p> : null}
      </div>
    </div>
  );
}
